import HeaderDash from "../../components/HeaderDash";
import Footer from "../../components/Footer";
import FeaturedDestination from "../../components/FeaturedDestination";
import NeedTour from "../../components/NeedTour";
import FilterDashboard from "../../components/FilterDashboard";
import RidesComponent from "../../components/RidesComponent";

function Rides() {
  return (
    <div>
      <HeaderDash />
      <link rel="stylesheet" href="https://fonts.googleapis.com" />

      <div className="w-[95%] mx-auto">
        <FilterDashboard />

        <p>Explore Rides</p>

        <div className="flex flex-col gap-2">
          <RidesComponent />
          <RidesComponent />
          <RidesComponent />
        </div>

        <FeaturedDestination />

        <NeedTour />
      </div>

      <Footer />
    </div>
  );
}

export default Rides;
